import { feedbackStore } from '../data/feedback-store.js';
import { renderProfileHeaderPill } from './profile-modal.js';

export function renderNavigation(currentTab) {
  const stats = feedbackStore.getProgressStats();
  
  const tabs = [
    { id: 'getting-started', label: '00. Getting Started', badge: 'Guide' },
    { id: 'overview', label: '01. Executive Overview', badge: 'Intro' },
    { id: 'assessment', label: '02. Brand Assessment', badge: 'Audit' },
    { id: 'demographics', label: '03. Demographic Intel', badge: 'Research' },
    { id: 'strategy', label: '04. Brand Strategy', badge: 'Blueprint' },
    { id: 'concepts', label: '05. Three Brand Concepts', badge: 'Creative' },
    { id: 'comparison', label: '06. Concept Comparison', badge: 'Matrix' },
    { 
      id: 'ballot', 
      label: '07. Feedback & Ballot', 
      badge: `${stats.completedCount}/${stats.totalCount}`, 
      highlight: true 
    }
  ];

  return `
    <aside class="sidebar">
      <div class="brand-header">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: var(--space-sm);">
          <div class="brand-logo-badge">Brand Proposal</div>
          <span class="mono" style="font-size: 10px; color: var(--text-tertiary);">2026 Refresh</span>
        </div>
        <h1 class="brand-title">Urban Village</h1>
        <p class="brand-subtitle">Brand Refresh Strategy &amp; Concepts</p>
      </div>

      <!-- Reviewer Profile Header Pill -->
      <div style="margin-bottom: var(--space-md);">
        ${renderProfileHeaderPill()}
      </div>

      <ul class="nav-menu" role="tablist">
        ${tabs.map(tab => `
          <li>
            <button 
              id="nav-${tab.id}" 
              class="nav-item-btn ${currentTab === tab.id ? 'active' : ''} ${tab.highlight ? 'nav-item-highlight' : ''}" 
              data-tab="${tab.id}"
              role="tab"
              aria-selected="${currentTab === tab.id}"
            >
              <span>${tab.label}</span>
              <span class="nav-badge ${tab.highlight && stats.percentage === 100 ? 'badge-success' : ''}">
                ${tab.badge}
              </span>
            </button>
          </li>
        `).join('')}
      </ul>

      <div class="sidebar-footer">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
          <span style="font-weight: 700; color: var(--text-secondary);">5 Sites Active</span>
          <span class="mono" style="color: var(--accent-primary);">HPW • RV • WP • RF • ON</span>
        </div>
        <div class="mono" style="font-size: 10px; color: var(--text-tertiary);">
          UVC Staff &amp; Leader Review
        </div>
      </div>
    </aside>
  `;
}
